module.exports = __webpack_public_path__ + "static/media/vuc.e10dc581.svg";